import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {NavLink} from 'react-router-dom';
import {Navbar, NavbarToggler, NavbarBrand, Collapse, Nav, NavItem} from 'reactstrap';
import {generateUrl, routes} from "helpers/routes";

class Navigation extends React.Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        onLogout: PropTypes.func.isRequired,
        onOnlineChange: PropTypes.func.isRequired,
    };

    componentWillMount() {
        this.setState({
            isOpen: false,
        });
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    }

    switchOnline(event) {
        const status = event.target.checked;
        this.props.onOnlineChange(status);
    }

    render() {
        const {user, onLogout} = this.props;

        return (
            <Navbar>
                <NavbarToggler onClick={::this.toggle} className={this.state.isOpen ? 'active' : ''}/>

                <NavbarBrand>
                    {user.name} {user.surname}
                </NavbarBrand>

                <Collapse isOpen={this.state.isOpen} id="navbar" navbar timeout={0}>
                    <Nav navbar>
                        <NavItem>
                            <h2>{user.operatorData && user.operatorData.businessName}</h2>
                            <p><FormattedMessage id="nav.logged_in" defaultMessage="Logged in" />: {user.name} {user.surname}</p>
                        </NavItem>
                        <NavItem>
                            <NavLink className="nav-link" to={generateUrl(routes.conversations)} onClick={::this.toggle}>
                                <FormattedMessage id="nav.conversation" defaultMessage="Conversations"/>
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className="nav-link" to={generateUrl(routes.catalogue)} onClick={::this.toggle}>
                                <FormattedMessage id="nav.catalogue" defaultMessage="Catalog"/>
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className="nav-link" to={generateUrl(routes.statistics)} onClick={::this.toggle}>
                                <FormattedMessage id="nav.statistics" defaultMessage="Statistics"/>
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className="nav-link" to={generateUrl(routes.prerecordedMessages)} onClick={::this.toggle}>
                                <FormattedMessage id="nav.prerecorded_messages" defaultMessage="Prerecorded messages"/>
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className="nav-link" to={generateUrl(routes.settings)} onClick={::this.toggle}>
                                <FormattedMessage id="nav.settings" defaultMessage="User settings"/>
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className="nav-link" to="#" onClick={() => {
                                onLogout();
                            }}>
                                <FormattedMessage id="nav.logout" defaultMessage="Logout"/>
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Collapse>

                <label className="switch">
                    <input className="switch__input" type="checkbox" onChange={::this.switchOnline} checked={user.online}/>
                    <span className="switch__slider"/>
                    <span className="switch__label">
                        <span className="switch__label--on">
                            <FormattedMessage id="nav.switch.online" defaultMessage="Online"/>
                        </span>
                        <span className="switch__label--off">
                            <FormattedMessage id="nav.switch.offline" defaultMessage="Offline"/>
                        </span>
                    </span>
                </label>
            </Navbar>
        )
    }
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/components/Navigation.jsx